import React from 'react';
import {
  FDBodyText,
  FDEmphasisSurface, FDIcon, FDPaper, FDStack,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import AddCardIcon from '@mui/icons-material/esm/AddCard';
import { useTheme } from '@material-ui/core/styles';
import { DataValueMap } from 'Helpers/Testing';


export const PaymentMethod = ({
  value,
  options,
  onChange,
}) => {
  const theme = useTheme();
  const conditionalWrapper = (children, isSelected) => {
    const maxWidth = '350px';
    return isSelected ? (
      <FDEmphasisSurface maxWidth={maxWidth}>{children}</FDEmphasisSurface>
    ) : (
      <FDPaper maxWidth={maxWidth}>{children}</FDPaper>
    );
  };

  return (
    <FDStack direction={'row'} spacing={2} wrap>
      {options.map((option) => {
        const isSelected = option.value === value;

        return (
          <Box onClick={() => onChange(option.value)} {...DataValueMap.init(`payment-method-${option.value}${isSelected ? '' : '-disabled'}`).build()}>
            {conditionalWrapper((
              <FDStack direction={'column'} spacing={2} padding={2}>
                {option.value === 'EstatePlanRecommendationPaymentMethodNewCard' ? (
                  <span style={isSelected ? { color: theme.palette.common.white } : {}}>
                    <AddCardIcon fontSize={'24px'} />
                  </span>

                ) : (
                  <FDIcon icon={'creditCard'} />
                )}
                <FDBodyText value={option.name} size={'lg'} />
              </FDStack>
            ), isSelected)}
          </Box>
        );
      })}
    </FDStack>
  );
};

PaymentMethod.defaultProps = {
};

PaymentMethod.propTypes = {
  value: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  onChange: PropTypes.func.isRequired,
};
